export enum reportStatusEnum {
  pending = "pending",
  approved = "approved",
  rejected = "rejected",
}
